"use strict";

angular.module("customer")
.controller("StockProductDetailsModal", function(
    $scope, $attrs, $state, $stateParams, $timeout, close, common, moment, Language, FlashBag, gettextCatalog,
    FormError, PatternService, CartItemService, StocksService, StockProductDetailsModalService,
    CoreProductVariantService,
    IS_MOBILE_APP, PRODUCT_ACQUISITION_METHOD
) {
    var _this = this;
    Language.initializeScope($scope, "language", "locale");
    FlashBag.clearAll();

    $scope.TABS = StocksService.TABS;
    $scope.PRODUCT_ACQUISITION_METHOD = PRODUCT_ACQUISITION_METHOD;

    $scope.index = $attrs.index;
    $scope.vendor = $attrs.vendor;

    $scope.closeOnQuantityUpdate = $attrs.closeOnQuantityUpdate;
    $scope.activeTab = $attrs.activeTab;
    $scope.isOrderTemplate = $attrs.isOrderTemplate;
    $scope.isSales = $scope.activeTab === $scope.TABS.SALES;
    $scope.isCustomerInventoryAvailable = (
        $scope.isSales && !$scope.isOrderTemplate && StocksService.validateDeliveryDate($scope.vendor)
    );
    $scope.isCustomDiscount = $scope.activeTab === $scope.TABS.CUSTOM_DISCOUNTS;
    $scope.isReturn = $scope.activeTab === $scope.TABS.RETURNS || $scope.activeTab === $scope.TABS.INVENTORY_RETURNS;

    $scope.isInventoryValidationRequired = $scope.showRebate = !$scope.isReturn;
    $scope.deliveryRules = $attrs.deliveryRules;
    $scope.customerProductAcquisitionMethod = $attrs.productAcquisitionMethod;
    $scope.period = "30";
    $scope.productHistoryData = [];
    $scope.showInventoryTarget = false;
    $scope.isProductInventoryFetching = false;
    $scope.is_quantity_changed = false;
    $scope.weekdays = common.getISOWeekdays($scope.locale);
    $scope.pattern = PatternService;


    $scope.catalogEntry = {};
    if ($attrs.catalogEntry) {
        $scope.catalogEntry = $attrs.catalogEntry;
    }
    $scope.catalogEntry.initial_order_quantity = $attrs.orderQuantity;
    $scope.catalogEntry.order_quantity = $attrs.orderQuantity;
    $scope.catalogEntry.total_measure = $attrs.totalMeasure;
    $scope.catalogEntry.initial_discounted_order_quantity = $attrs.discountedOrderQuantity;
    $scope.catalogEntry.discounted_order_quantity = $attrs.discountedOrderQuantity;
    $scope.catalogEntry.discounted_total_measure = $attrs.discountedTotalMeasure;
    $scope.product = $scope.catalogEntry.product;
    $scope.title = $scope.product.Name[$scope.language];

    $scope.ignoreQuantity = $attrs.ignoreQuantity;
    $scope.isVariableMeasure = $attrs.isVariableMeasure;

    $scope.isMobileApp = IS_MOBILE_APP;
    $scope.showPdf = false;
    $scope.isPDFLoaded = false;
    $scope.isPDFError = false;

    if ($scope.product.attachments.length) {
        $scope.pdfUrl = $scope.product.attachments[0].file.url;
    }

    $scope.isProductVariant = false;
    $scope.catalogEntryVariant = null;
    $scope.variantOptions = [];
    if (
        $scope.vendor.allow_product_variants
        && $scope.catalogEntry.product.has_variants
        && $scope.catalogEntry.catalog_entry_variants.length
    ) {
        $scope.isProductVariant = true;
        if ($attrs.catalogEntryVariant) {
            $scope.catalogEntryVariantId = $attrs.catalogEntryVariant.id;
            $scope.catalogEntryVariant = _.find($scope.catalogEntry.catalog_entry_variants, function(catalogEntryVariant) {
                return catalogEntryVariant.id === $scope.catalogEntryVariantId;
            });
        }

        if (!$scope.catalogEntryVariant) {
            for (var i = 0; i < $scope.catalogEntry.catalog_entry_variants.length; i++) {
                if ($scope.catalogEntry.catalog_entry_variants[i].order_quantity) {
                    $scope.catalogEntryVariant = $scope.catalogEntry.catalog_entry_variants[i];
                    break;
                }
            }
            if (!$scope.catalogEntryVariantId && !$scope.catalogEntryVariant) {
                $scope.catalogEntryVariant = $scope.catalogEntry.catalog_entry_variants[0];
            }
        }

        $scope.variantOptions = $scope.vendor.variant_options;
        updateVariantValidValues();
        updateSelectedVariantOptions();
        updateVisibleVariantOptions();
    }

    function updateVariantValidValues() {
        var catalogEntryVariants = $scope.catalogEntry.catalog_entry_variants;
        angular.forEach($scope.variantOptions, function(optionValue) {
            var values = [];
            angular.forEach(optionValue.values, function(value) {
                angular.forEach(catalogEntryVariants, function(catalogEntryVariant) {
                    values = values.concat(catalogEntryVariant.product_variant.option_values.filter(function(value_) {
                        return value_ === value.id;
                    }));
                });
            });
            optionValue.isValid = !!(values.length);
        });
    }

    function updateVisibleVariantOptions() {
        angular.forEach($scope.variantOptions, function(variantOption) {
            angular.forEach(variantOption.values, function(value) {
                value.visible = false;
            });
        });

        var catalogEntryVariants = $scope.catalogEntry.catalog_entry_variants;
        angular.forEach(catalogEntryVariants, function(catalogEntryVariant) {
            angular.forEach($scope.variantOptions, function(variantOption) {
                angular.forEach(variantOption.values, function(value) {
                    if (catalogEntryVariant.product_variant.option_values.includes(value.id)) {
                        value.visible = true;
                    }
                });
            });
        });
    }

    function updateSelectedVariantOptions() {
        if (!$scope.variantOptions.length || !$scope.catalogEntryVariant) {
            return;
        }

        var productVariantOptionValues = $scope.catalogEntryVariant.product_variant.option_values;
        angular.forEach($scope.variantOptions, function(option) {
            var optionValues = option.values.map(function(optionValue) {
                return optionValue.id
            });
            var intersection = productVariantOptionValues.filter(function(element) {
                return optionValues.includes(element)
            });
            if (intersection.length && intersection.length === 1) {
                option.selected = parseInt(intersection[0]);
            }
        });
    }

    this.updateSelectedProductVariant = function() {
        $timeout(function() {
            var selectedOptionValues = $scope.variantOptions.filter(function(option) {
                return option.isValid;
            }).map(function(option) {
                return option.selected;
            });
            $scope.catalogEntryVariant = null;
            angular.forEach($scope.catalogEntry.catalog_entry_variants, function(catalogEntryVariant) {
                if (
                    !$scope.catalogEntryVariant
                    && _.isEqual(catalogEntryVariant.product_variant.option_values.sort(), selectedOptionValues.sort())
                ) {
                    $scope.catalogEntryVariant = catalogEntryVariant;
                }
            });
            if (!$scope.catalogEntryVariant && selectedOptionValues.length && selectedOptionValues[0]) {
                angular.forEach($scope.catalogEntry.catalog_entry_variants, function(catalogEntryVariant) {
                    if (
                        !$scope.catalogEntryVariant
                        && catalogEntryVariant.product_variant.option_values.indexOf(selectedOptionValues[0]) >= 0
                    ) {
                        $scope.catalogEntryVariant = catalogEntryVariant;
                    }
                });
                updateSelectedVariantOptions();
            }
            if (!$scope.catalogEntryVariant) {
                $scope.catalogEntryVariant = $scope.catalogEntry.catalog_entry_variants[0];
                updateSelectedVariantOptions();
            }
            updateVisibleVariantOptions();
        });
    };

    this.getProductVariantName = function(optionValues) {
        return CoreProductVariantService.getProductVariantName($scope.variantOptions, optionValues);
    };

    this.collapsePdf = function() {
        $scope.showPdf = !$scope.showPdf;
    };

    $scope.onLoad = function() {
        $scope.isPDFLoaded = true;
    }

    $scope.onError = function(error) {
        $timeout(function() {
            $scope.isPDFError = true;
        });
    }

    this.useVariableMeasure = function() {
        if ($scope.isProductVariant) {
            return false;
        }
        return (
            $scope.vendor.enable_product_measure_management
            && $scope.isVariableMeasure
            && CartItemService.isOnDeliverySelected($scope.vendor)
        );
    };

    this.isVariantOptionsValid = function() {
        if (!$scope.isProductVariant) {
            return true;
        }
        if ($scope.isProductVariant && !$scope.catalogEntryVariant) {
            return false;
        }
        if ($scope.isProductVariant && $scope.catalogEntryVariantId) {
            return true;
        }
        var isValid = true;
        angular.forEach($scope.variantOptions, function(variantOption) {
            if (variantOption.isValid && !variantOption.selected) {
                isValid = false;
            }
        });
        return isValid;
    };

    this.isCartItemQuantityValid = function() {
        if ($scope.isProductVariant) {
            return true;
        }
        if ($scope.isReturn) {
            return true;
        }

        var quantity = $scope.catalogEntry.order_quantity;
        if ($scope.isCustomDiscount) {
            quantity = $scope.catalogEntry.discounted_order_quantity;
        }

        return CartItemService.isCartItemQuantityValid(
            $scope.catalogEntry.quantity_min,
            $scope.catalogEntry.quantity_max,
            quantity
        );
    };

    this.isProductMultiplierValid = function() {
        if ($scope.isReturn) {
            return true;
        }

        var quantity = $scope.catalogEntry.order_quantity;
        if ($scope.isCustomDiscount) {
            quantity = $scope.catalogEntry.discounted_order_quantity;
        }
        else if ($scope.isProductVariant && $scope.catalogEntryVariant) {
            quantity = $scope.catalogEntryVariant.order_quantity;
        }

        return CartItemService.isProductMultiplierValid($scope.catalogEntry.packaging_quantity, quantity);
    };

    this.isProductQuantityPatternValid = function() {
        if ($scope.ignoreQuantity) {
            return true;
        }
        var quantity = $scope.catalogEntry.order_quantity;
        if ($scope.isCustomDiscount) {
            quantity = $scope.catalogEntry.discounted_order_quantity;
        }
        else if ($scope.isProductVariant && $scope.catalogEntryVariant) {
            quantity = $scope.catalogEntryVariant.order_quantity;
        }

        return CartItemService.isProductQuantityPatternValid(quantity);
    };

    this.getProductQuantityPatternError = function() {
        return CartItemService.getProductQuantityPatternError();
    };

    this.getQuantityMinMaxError = function() {
        if ($scope.isProductVariant) {
            return true;
        }
        if ($scope.isReturn) {
            return true;
        }
        return CartItemService.getQuantityMinMaxError($scope.catalogEntry.quantity_min, $scope.catalogEntry.quantity_max);
    };

    this.getProductMultiplierError = function() {
        return CartItemService.getProductMultiplierError($scope.catalogEntry.packaging_quantity);
    };

    this.isProductInventoryQuantityValid = function() {
        if (!$scope.isInventoryValidationRequired) {
            return true;
        }

        var quantity = parseFloat($scope.catalogEntry.order_quantity);
        if ($scope.isProductVariant && $scope.catalogEntryVariant) {
            quantity = parseFloat($scope.catalogEntryVariant.order_quantity);
            return (
                !$scope.vendor.is_cart_vendor_exists
                || !$scope.vendor.block_order_when_out_of_stock
                || CartItemService.isProductInventoryQuantityValid($scope.catalogEntryVariant.inventory_quantity, quantity)
            );
        }

        if (typeof $scope.catalogEntry.discounted_order_quantity !== 'undefined') {
            quantity += parseFloat($scope.catalogEntry.discounted_order_quantity);
        }
        return (
            !$scope.vendor.is_cart_vendor_exists
            || !$scope.vendor.block_order_when_out_of_stock
            || CartItemService.isProductInventoryQuantityValid($scope.catalogEntry.inventory_quantity, quantity)
        );
    };

    this.getProductInventoryQuantityError = function() {
        if ($scope.isProductVariant && $scope.catalogEntryVariant) {
            return CartItemService.getProductInventoryQuantityError($scope.catalogEntryVariant.inventory_quantity);
        }
        return CartItemService.getProductInventoryQuantityError($scope.catalogEntry.inventory_quantity);
    };

    this.isOutOfStock = function() {
        if (!$scope.isInventoryValidationRequired) {
            return false;
        }
        if ($scope.isProductVariant && $scope.catalogEntryVariant) {
            return $scope.vendor.is_cart_vendor_exists && StocksService.isProductVariantOutOfStock($scope.catalogEntryVariant);
        }
        return $scope.vendor.is_cart_vendor_exists && StocksService.isOutOfStock($scope.catalogEntry);
    };

    this.isExpectedAvailabilityDateValid = function() {
        var expectedAvailabilityDate = $scope.catalogEntry.expected_availability_date;
        return expectedAvailabilityDate && moment(expectedAvailabilityDate).isSameOrAfter(moment());
    };

    this.showAlternativeProductButton = function() {
        if ($scope.isProductVariant) {
            return false;
        }
        var alternativeProductKeywords = $scope.catalogEntry.alternative_product_keywords;
        if (!$scope.isCustomerInventoryAvailable || !alternativeProductKeywords) {
            return false;
        }
        return this.isOutOfStock();
    };

    this.searchSuggestedAlternative = function() {
        this.close();
        $state.go("stocks", {
            search: $scope.catalogEntry.alternative_product_keywords,
            vendorId: $scope.vendor.id,
            lastCatalog: $stateParams.catalog,
            catalog: undefined
        });
    };

    this.close = function() {
        $scope.$element.modal("hide");
        $scope.$element.remove();
        if ($scope.catalogEntryVariant) {
            close.apply(this, [{
                preferred: $scope.catalogEntry.preferred,
                inventoryProduct: $scope.product.inventory_product,
                quantity: $scope.catalogEntry.order_quantity,
                discountedQuantity: $scope.catalogEntry.discounted_order_quantity,
                variantQuantity: $scope.catalogEntryVariant.order_quantity,
                catalogEntryVariant: $scope.catalogEntryVariant
            }]);
        }
        else if ($scope.is_quantity_changed) {
            close.apply(this, [{
                preferred: $scope.catalogEntry.preferred,
                inventoryProduct: $scope.product.inventory_product,
                quantity: $scope.catalogEntry.order_quantity,
                discountedQuantity: $scope.catalogEntry.discounted_order_quantity
            }]);
        }
        else {
            close.apply(this, [{
                preferred: $scope.catalogEntry.preferred,
                inventoryProduct: $scope.product.inventory_product,
                quantity: $scope.catalogEntry.initial_order_quantity,
                discountedQuantity: $scope.catalogEntry.initial_discounted_order_quantity
            }]);
        }
    };

    this.updateQuantity = function() {
        FlashBag.clearAll();
        if (this.isOrderedQuantityValid()) {
            var promise;

            if ($scope.isProductVariant) {
                $scope.catalogEntry.order_quantity = 0;
                angular.forEach($scope.catalogEntry.catalog_entry_variants, function(catalogEntryVariant) {
                    $scope.catalogEntry.order_quantity += parseFloat(catalogEntryVariant.order_quantity);
                });
            }

            var baseQuantity = $scope.catalogEntry.order_quantity;
            var quantity = baseQuantity;
            var discountedQuantity = $scope.catalogEntry.discounted_order_quantity;
            if ($scope.catalogEntryVariant) {
                quantity = $scope.catalogEntryVariant.order_quantity;
            }

            if ($scope.activeTab === $scope.TABS.INVENTORY_RETURNS) {
                promise = CartItemService.saveInventoryReturnQuantity(
                    $scope.catalogEntry, $scope.catalogEntryVariant, quantity, $scope.vendor
                );
            }
            else if ($scope.activeTab === $scope.TABS.RETURNS) {
                promise = CartItemService.saveReturnQuantity(
                    $scope.catalogEntry, $scope.catalogEntryVariant, quantity, $scope.vendor
                );
            }
            else if ($scope.activeTab === $scope.TABS.CUSTOM_DISCOUNTS) {
                promise = CartItemService.saveDiscountedQuantity(
                    $scope.catalogEntry, $scope.catalogEntryVariant, discountedQuantity, $scope.vendor,
                    $scope.catalogEntry.custom_discounted_price
                );
            }
            else {
                promise = CartItemService.saveSaleQuantity(
                    $scope.catalogEntry, $scope.catalogEntryVariant, quantity, $scope.vendor
                );
            }

            promise.then(function onSuccess() {
                $scope.is_quantity_changed = true;
                if ($scope.isCustomDiscount) {
                    $scope.catalogEntry.discounted_order_quantity = discountedQuantity;
                }
                else {
                    $scope.catalogEntry.order_quantity = baseQuantity;
                }
                if ($scope.closeOnQuantityUpdate || !$scope.isProductVariant) {
                    _this.close();
                }
                else {
                    var alertMessage = gettextCatalog.getString("Cart was updated successfully.");
                    FlashBag.alertWithContainer("success", "flash-add-to-cart-product-details-modal", alertMessage);
                }
            });
        }
    };

    this.validateInventoryTarget = function($event) {
        $scope.deliveryInventoryTargetForm.$setSubmitted();
        if ($scope.deliveryInventoryTargetForm.$valid) {
            saveInventoryTarget($event);
        }
        else {
            FormError.focus("deliveryInventoryTargetForm");
        }
    };

    this.isOrderedQuantityValid = function() {
        return (
            this.isVariantOptionsValid() && this.isProductMultiplierValid()
            && this.isCartItemQuantityValid() && this.isProductQuantityPatternValid()
        );
    }

    function saveInventoryTarget(e) {
        e.preventDefault();
        $scope.isProductInventoryFetching = true;
        FlashBag.clearAll();

        var catalogEntry = $scope.catalogEntry;
        var inventoryProduct = $scope.product.inventory_product;
        var serviceFunction = StockProductDetailsModalService.setDefaultInventoryTarget;
        if ($scope.product.inventory_product.delivery_inventory_target.length) {
            serviceFunction = StockProductDetailsModalService.setDeliveryInventoryTarget;
        }

        serviceFunction(catalogEntry, inventoryProduct).then(
            function onSuccess(data) {
                $scope.product.inventory_product = data;
                mergeDeliveryRulesAndSavedDeliveryTarget();
                $scope.deliveryInventoryTargetForm.$setPristine();
                var message = gettextCatalog.getString("The target values are updated successfully.");
                FlashBag.alertWithContainer("success", "stock-product-detail", message);
            },
            function onError() {
                var message = gettextCatalog.getString("There was an error when updating the target values.");
                FlashBag.alertWithContainer("danger", "stock-product-detail", message);
            }
        ).finally(function() {
            $scope.isProductInventoryFetching = false;
        });
    }

    function mergeDeliveryRulesAndSavedDeliveryTarget() {
        var availableInventoryTarget = [];
        angular.forEach($scope.deliveryRules, function(deliveryRule, key) {
            if (deliveryRule.enabled) {
                var inventoryTargetRule = _.find($scope.product.inventory_product.delivery_inventory_target, function(o) {
                    return o.delivery_weekday === deliveryRule.weekday;
                });
                var availableInventoryTargetRule = _.find(availableInventoryTarget, function(o) {
                    return o.delivery_weekday === deliveryRule.weekday;
                });
                if (!availableInventoryTargetRule) {
                    if (inventoryTargetRule) {
                        availableInventoryTarget.push({
                            "delivery_weekday": deliveryRule.weekday,
                            "target_inventory_level": inventoryTargetRule.target_inventory_level
                        });
                    }
                    else {
                        availableInventoryTarget.push({
                            "delivery_weekday": deliveryRule.weekday,
                            "target_inventory_level": 0
                        });
                    }
                }
            }
        });
        $scope.product.inventory_product.delivery_inventory_target = availableInventoryTarget;
    }

    this.updateGraph = function(period) {
        var date = moment().subtract(parseInt(period), "days");
        $scope.options.scales.xAxes[0].ticks.min = date.format("YYYY-MM-DD");
        var orderedAfter = date.utc().format();
        $scope.productHistoryData[0] = StockProductDetailsModalService.queryProductHistory($scope.product.id, orderedAfter);
    };

    $scope.options = {
        tooltips: {
            enabled: false
        },
        scales: {
            yAxes: [
                {
                    ticks: {
                        min: 0,
                        suggestedMax: 6
                    }
                }
            ],
            xAxes: [
                {
                    type: "time",
                    time: {
                        displayFormats: {
                            quarter: "[Q]Q - YYYY",
                            millisecond: "LL"
                        }
                    },
                    ticks: {
                        max: moment(),
                        minRotation: 7,
                        maxRotation: 7
                    }

                }
            ]
        },
        elements: {
            line: {
                tension: 0.1
            }
        }
    };

    this.updateGraph($scope.period);
    mergeDeliveryRulesAndSavedDeliveryTarget();
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/stock/catalog-entry/stock-product-details.modal.js
// module id = 923
// module chunks = 0